const securityModal = document.getElementById('securityModal');
const securityModalButton = document.getElementById('securityModalButton');
const pwInput = document.querySelector('input[name=password]');
const pwInput2 = document.querySelector('input[name=confirmpassword]');
const passwordForm = document.getElementById('setpassword');
const securityModalMessages = document.getElementById('securityModalMessages');
var htmlBody = document.getElementById('mainbody');

/**
 * Set up the password modal functionality
 */
const initSecurityModal = function () {
    document.getElementById('security').addEventListener("click", showSecurityModal);
    document.getElementById('closeSecurityModal').addEventListener("click", hideSecurityModal);
}

/**
 * Shows the security modal
 */
const showSecurityModal = function () {
    securityModal.classList.add('show');
    securityModal.setAttribute('aria-hidden', 'false');
    htmlBody.style.overflow = 'hidden';
}

/**
 * Hides the security modal
 */
const hideSecurityModal = function () {
    securityModal.classList.remove('show');
    securityModal.setAttribute('aria-hidden', 'true');
    htmlBody.style.overflow = '';
}

/**
 * Bind the events on the password fields
 */
const initPasswordFields = function () {
    pwInput.addEventListener("keyUp", bindPasswordCheck);
    pwInput2.addEventListener("keyup", bindPasswordCheck);
}

/**
 * Check to see if we have content in the fields before allowing the button to work
 */
const bindPasswordCheck = function () {
    let pwData = pwInput.value;
    let pwData2 = pwInput2.value;
    if ((pwData.length > 5) && (pwData2.length > 5)) {
        enableSecurityModalButton();
    } else {
        disableSecurityModalButton();
    }
}

/**
 * Enable the submit button on the password form
 */
const enableSecurityModalButton = function () {
    securityModalButton.classList.remove('disabled');
    securityModalButton.removeAttribute('disabled');
}

/**
 * Disable the submit button on the password form
 */
const disableSecurityModalButton = function () {
    securityModalButton.classList.add('disabled');
    securityModalButton.setAttribute('disabled', 'disabled');
}

const initPasswordForm = function () {
    let pristine = new Pristine(passwordForm);
    passwordForm.addEventListener("submit", (e) => {
        e.preventDefault();
        disableSecurityModalButton();
        let valid = pristine.validate();
        if (valid === true) {
            sendPasswordForm();
        } else {
            enableSecurityModalButton();
            for (let [key, value] of Object.entries(pristine.getErrors())) {
                let errors = value['errors'];
                errors.forEach((error) => {
                    securityModalMessages.innerHTML = securityModalMessages.textContent + error + '<br>';
                });
            }
        }
    });
}

/**
 * Deal with the form submission
 */
const sendPasswordForm = function () {
    let FD = new FormData(passwordForm);
    let req = new XMLHttpRequest();
    req.addEventListener('load', processPasswordResponse);
    req.open("POST", passwordForm.action);
    req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    req.send(FD);
}

/**
 * Handle the server response from the password update
 * @param res
 */
const processPasswordResponse = function (res) {
    let resData = JSON.parse(res.target.responseText);
    if (resData.status === 1) {
        window.location.href = resData.link;
    } else {
        enableSecurityModalButton();
        securityModalMessages.innerHTML = resData.message;
    }
}

// -----------------

//Polyfill for pristine, because the NPM version is out of date
Pristine.addValidator(
    'equals',
    function (val, otherFieldSelector) {
        var other = document.querySelector(otherFieldSelector);
        return other && ((!val && !other.value) || other.value === val);
    },
    'Please make sure you have put the same password in both boxes',
    1,
    true
);

document.addEventListener("DOMContentLoaded", () => {
    initSecurityModal();
    initPasswordFields();
    initPasswordForm();
});

